(() => {
  const replaceHeading = (heading, tagName) => {
    if (!heading || heading.tagName.toLowerCase() === tagName) return heading;
    const next = document.createElement(tagName);
    for (const attr of heading.attributes) next.setAttribute(attr.name, attr.value);
    next.innerHTML = heading.innerHTML;
    heading.replaceWith(next);
    return next;
  };

  const run = () => {
    if (!document.querySelector('main[data-template^="index"]')) return;
    document.body.classList.add('zeesmoto-homepage-audit');

    document.querySelectorAll('.announcement-bar__text').forEach((el) => {
      if (el.textContent.trim().toUpperCase() === 'FREE SHIPPING US | CA') el.textContent = 'Free shipping — US & Canada';
    });
    document.querySelectorAll('.zeesmoto-hero-copy__heading span').forEach((el) => {
      if (el.textContent.trim().toUpperCase() === 'ENGINEERED FOR SPEED.') el.textContent = 'Engineered for speed.';
    });
    document.querySelectorAll('main h4').forEach((el) => {
      if (el.textContent.trim().toUpperCase() === 'CHOOSE YOUR ACTIVITY') {
        el.textContent = 'Choose your activity';
        replaceHeading(el, 'h3');
      }
    });
    document.querySelectorAll('.product-card h5').forEach((el) => replaceHeading(el, 'h3'));

    const pageH1s = [...document.querySelectorAll('main h1')];
    pageH1s.slice(1).forEach((el) => replaceHeading(el, 'h2'));

    const protection = [...document.querySelectorAll('.zeesmoto-hero-copy__heading')].filter((el) =>
      el.textContent.replace(/\s+/g,' ').trim().toLowerCase() === 'ride with confidence. built to protect.'
    );
    protection.slice(1).forEach((el) => el.closest('.shopify-section,section')?.remove());

    const heroes = [...document.querySelectorAll('main .shopify-section')].filter((section) => section.querySelector('.zeesmoto-hero-copy'));
    heroes.slice(1).forEach((section) => section.classList.add('zm-hero--secondary'));
    heroes.forEach((hero) => {
      const copy = hero.querySelector('.zeesmoto-hero-copy');
      if (!copy || copy.querySelector('.zeesmoto-hero-copy__actions')) return;
      const actions = document.createElement('div');
      actions.className = 'zeesmoto-hero-copy__actions';
      const secondary = copy.querySelector('.zeesmoto-hero-copy__button');
      if (secondary) actions.append(secondary);
      const shopNow = [...hero.querySelectorAll('a')].find((a) => a.textContent.trim().toLowerCase() === 'shop now');
      if (shopNow) {
        shopNow.classList.add('zeesmoto-hero-copy__button','zm-audit-primary');
        actions.prepend(shopNow);
      }
      if (actions.children.length) copy.append(actions);
    });

    document.querySelectorAll('.quick-add__button--choose').forEach((button) => {
      button.setAttribute('aria-label','Choose product options');
      const label = button.querySelector('.add-to-cart-text__content span span');
      if (label) label.textContent = 'Choose options';
    });

    // Footer restructuring removed 2026-09-12: sections/footer.liquid now owns the footer layout on every page.
  };
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();